import React, { useState, useEffect, useCallback } from 'react'
import _ from 'lodash';
import FileUploadWidget from './FileUploadWidget'
import axios from 'axios';
import FindingAPI from 'restAPI/FindingAPI';
import message from './CustomMessage';

const UploadFileList = ({ uploadDoc, updateAttachments = _.noop, fileUploaded, ...restProps }) => {
    const [attachments, setAttachments] = useState(() => _.map(restProps.attachments, (file) => ({...file, percent: 100})));
    const filesNotSupported = React.useRef([]);

    useEffect(() => {
        _.isEmpty(restProps.attachments) && !_.isEmpty(attachments) && setAttachments([]);
    }, [restProps.attachments, attachments])

    const allFileUploaded = useCallback((allAttachments) => {
        const areAllFilesUploaded = allAttachments.every(attchment => attchment.percent === 100);
        if (areAllFilesUploaded) {
            if (filesNotSupported.current.length > 0) {
                const _attachments = _.filter(allAttachments, (doc) => filesNotSupported.current.indexOf(doc.id) === -1)
                setAttachments(_attachments);
                updateAttachments(_attachments, true);
            }
            fileUploaded();
        }
    }, [fileUploaded, updateAttachments])


    const uploadFile = useCallback(async () => {
        const { signedUrl, file, name, id } = uploadDoc;
        const cancelTokenSource = axios.CancelToken.source();

        setAttachments(attachment => [...attachment, { name, id, percent: 0, cancelTokenSource }]);

        const formData = new FormData();
        formData.append('file', file);
        const { promise, cancel } = FindingAPI.checkIfFileIsAllowed(formData);

        promise.then((res) => {
            if (!res) {
                message.error(`${uploadDoc.file?.type ? uploadDoc.file.type : 'File type'} is not supported.`);
                filesNotSupported.current = [...filesNotSupported.current, id];
                setAttachments(attachment => {
                    const currentAttachment = attachment.find(file => file.id === id);
                    currentAttachment.percent = 100;
                    allFileUploaded([...attachment]);
                    return [...attachment];
                })
            } else {
                const handleProgress = (id) => (progressEvent) => {
                    setAttachments(attachment => {
                        const currentAttachment = attachment.find(file => file.id === id);
                        currentAttachment.percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                        if (currentAttachment.percent === 100) allFileUploaded([...attachment]);
                        return [...attachment];
                    })
                }
                axios({ method: 'put', url: signedUrl, data: file, onUploadProgress: handleProgress(id), cancelToken: cancelTokenSource.token })
            }
        });
        return cancel;
    }, [uploadDoc, allFileUploaded])

    const deleteFile = (id) => {
        const deletedItem = _.find(attachments, (doc) => doc.id === id);
        const _attachments = _.filter(attachments, (doc) => doc.id !== id)
        if (deletedItem.percent !== 100) {
            deletedItem.cancelTokenSource && deletedItem.cancelTokenSource.cancel();
            allFileUploaded([..._attachments])
        }
        setAttachments(_attachments);
        updateAttachments(_attachments, true);
    }

    useEffect(() => {
        if (!_.isEmpty(uploadDoc)) {
            uploadFile(uploadDoc);
        } else {
            allFileUploaded(restProps.attachments || [])
        }
    }, [uploadFile, uploadDoc, restProps.attachments, allFileUploaded])

    if (!attachments.length) {
        return null;
    }
    return (
        < div className="d-flex">
            {attachments.map(file => {
                return file.name && <FileUploadWidget key={file.id} file={file} deleteFile={deleteFile} upload={true} />
            })
            }
        </div>
    )
}

export default UploadFileList;